import styled, { css } from 'styled-components'
import { mediaQueries } from '../../providers/MediaQueryProvider'

export const Container = styled.div<{ $type: 'success' | 'info' | 'error' }>`
  padding: var(--space-200) var(--space-300);
  display: flex;
  align-items: center;
  gap: var(--space-400);
  border-radius: var(--radius-brand);
  font-weight: var(--font-weight-medium);

  ${({ $type }) =>
    $type === 'success' &&
    css`
      background: var(--bg-success);
      color: var(--text-on-brand);
    `}

  ${({ $type }) =>
    $type === 'info' &&
    css`
      background: var(--bg-primary-invert);
      color: var(--text-primary-invert);
    `}

  ${({ $type }) =>
    $type === 'error' &&
    css`
      background: var(--bg-critical);
      color: var(--text-on-brand);
    `}

  ${mediaQueries.tablet} {
    padding: var(--space-300) var(--space-400);
    max-width: 870px;
    width: 80vw;
  }

  ol {
    padding-left: var(--space-500);
    list-style-type: decimal;
  }

  a {
    text-decoration: underline;
  }
`

export const Message = styled.div`
  white-space: pre-line;
  flex: 1;
`

export const Close = styled.button`
  padding: var(--space-200);
  margin: var(--space-n200);
  color: inherit;
`
